import React from "react"

const Content = ({ text, children }) => {
  return <div>{children || text}</div>
}

export { Content }
